import { render, staticRenderFns } from "./CAPage.vue?vue&type=template&id=4a5b62e8&"
import script from "./CAPage.vue?vue&type=script&lang=js&"
export * from "./CAPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a5b62e8')) {
      api.createRecord('4a5b62e8', component.options)
    } else {
      api.reload('4a5b62e8', component.options)
    }
    module.hot.accept("./CAPage.vue?vue&type=template&id=4a5b62e8&", function () {
      api.rerender('4a5b62e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/security/CAPage.vue"
export default component.exports